// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { BaseResponseZendeskConfigChatFoundResponse } from '../../types';

/**
 * get
 *
 * @export
 * @tags zendesk-config-chat-controller
 * @link [GET] /zendeskConfigs/chat
 */
export function getZendeskConfigsChat(): Promise<BaseResponseZendeskConfigChatFoundResponse>;
export function getZendeskConfigsChat(
    options: ApiOptions<never, never>
): Promise<BaseResponseZendeskConfigChatFoundResponse>;
export function getZendeskConfigsChat(
    options?: ApiOptions<never, never>
): Promise<BaseResponseZendeskConfigChatFoundResponse> {
    return request<never, never, never>('/zendeskConfigs/chat', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getZendeskConfigsChat',
    });
}

export const meta = [
    { tags: ['zendesk-config-chat-controller'], path: '/zendeskConfigs/chat', method: 'get' },
];
